import { render, staticRenderFns } from "./VendorPortalWorkflowCards.vue?vue&type=template&id=1706dc89"
import script from "./VendorPortalWorkflowCards.vue?vue&type=script&lang=js"
export * from "./VendorPortalWorkflowCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports